export default [
    {
        name: '小于30万',
        value: 0
    },
    {
        name: '30万-100万',
        value: 1
    },
    {
        name: '100万以上',
        value: 2
    },
]